const Menu =  [
    { header: 'Sys Admin' },
    {
        path    : '/',
        title   : 'Dashboard',    
        name    : 'dashboard',  
        icon    : 'dashboard', 
        meta    : {breadcrumb:false}
    }, 
    {
        path    : '/signup',
        title   : 'Calon Signup',    
        name    : 'signup',  
        icon    : 'group', 
        meta    : {breadcrumb:true}
    },       
    {
        path    : '/signup/calon',
        title   : 'Calon Administrasi',    
        name    : 'signup/calon',  
        icon    : 'account_box', 
        meta    : {breadcrumb:true}
    },
    {
        path    : '/signup/calon/payment/',
        title   : 'Calon Membayar',    
        name    : 'signup/calon/payment',  
        icon    : 'monetization_on', 
        meta    : {breadcrumb:true}
    },
    {
        path    : '/calon/rekap',
        title   : 'Rekap Data',    
        name    : 'calon/rekap',  
        icon    : 'list', 
        meta    : {breadcrumb:true}
    },
    
    //NON MENU
    { group: 'dashboard',
      visible: false,
      items:[
        { title : 'Explore', name: 'explore', meta:{breadcrumbs:false} },
        { title : 'Live', name: 'live', meta:{breadcrumbs:false, public:true} },
      ]
    },   
    { group: 'profile',
      visible: false,
      items:[
        { title : 'Profile', meta:{breadcrumbs:false} },
        { title : 'Update Profile', name: 'form' },        
      ]
    },
    {
        group: 'adm',
        visible : false,
        items: [
            { title : 'Mata Pelajaran', name: 'matpel/form'},
            { title : 'Provinsi', name: 'provinsi/form'},
            { title : 'Kota/Kab', name: 'kota/form' },
            { title : 'Kecamatan', name: 'kecamatan/form' },            
            { title : 'Kelurahan', name: 'kelurahan/form' },            
        ]
    },        
    { group: 'calon',
      visible: false,
      items:[
        { title : 'calon Form', name: 'form' },
        { title : 'calon View', name: 'view' },     
      ]
    },
    { group: 'signup',
      visible: false,
      items:[
        { title : 'Signup Form', name: 'form' },
        { title : 'Calon Form', name: 'calon/form' }, 
        { title : 'Calon Form', name: 'calon/view' }, 
        { title : 'Payment', name: 'calon/payment' },        
        { title : 'Payment Form', name: 'calon/payment/form' },        
        { title : 'Payment View', name: 'calon/payment/view' },
        { title : 'Payment Rekap', name: 'calon/payment/excel' },                
      ]
    },
    { group: 'user',
      visible: false,
      items:[
        { title : 'Calon', name: 'form' },        
      ]
    },    
    {
        title   : 'Auth',
        group   : 'rbac',
        visible: false,                   
        items: [            
            {title: 'User', name:'user/form'},
            {title: 'Permissions', name: 'permissions/form'},
            {title: 'Permissions', name: 'permissions/view'},
            {title: 'Roles', name: 'roles/form'},
            {title: 'Roles', name: 'roles/view'},
            {title: 'Assignment', name: 'assignment/view'}            
        ]
    },
];

import Remenu from '@/util/remenu';
export default Remenu(Menu);
